import { map, get, capitalize, find } from "lodash"
import { createSelector } from "reselect"
import { computeSecurityInfo } from "helpers/topics"
import { getRawPortfolios } from "./portfolios"
import { getPermissions, getFavoritesAsObject } from "./items"

const EMPTY_ARRAY = []
const getRawTopics = state => get(state, "global.data.accountResearchTopics.data.researchTopics", EMPTY_ARRAY)

export const getCurrentLoadedTopic = state => get(state, "global.data.topic.data.resource")
export const getTopics = createSelector(
  [getRawTopics, getRawPortfolios],
  (topics, portfolios) =>
    map(topics, topic => {
      const info = []
      const { securityId, portfolioId } = topic.referenceInstrument || {}

      info.push({ label: "Type", value: "Research Topic" })

      let refInstrumentInfo
      if (securityId) {
        refInstrumentInfo = computeSecurityInfo(securityId)
      }
      if (portfolioId) {
        const portfolio = find(portfolios, ({ id }) => id === portfolioId)
        refInstrumentInfo = {
          name: portfolio.name,
          model: portfolio.defaultModelId,
        }
      }

      info.push({
        label: "Reference Instrument",
        values: map(refInstrumentInfo, (value, key) => ({
          label: `${capitalize(key)}:`,
          value,
        })),
      })

      return {
        ...topic,
        ...(portfolioId && { portfolioName: refInstrumentInfo.name }),
        label: topic.name,
        resourceType: "topic",
        info,
      }
    }),
)

export const getTopicsWithMeta = createSelector(
  [getTopics, getPermissions, getFavoritesAsObject],
  (topics, permissions, favorites) => map(topics, topic => ({
    ...topic,
    ...find(permissions, ({ id }) => id === topic.id),
    shortType: "t",
    type: "Research topic",
    isFavorite: get(favorites, topic.id, false),
  })),
)
